import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, ValidationErrors, Validator } from '@angular/forms';
import { BulkWorkOrderHeader, SingleEquipmentForm } from '../../../../form-model/bulk-workorder-header.form.model';

@Injectable({
  providedIn: 'root',
})
export class EquipmentNumberUniqueValidator implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const equipmentsControl = control as FormArray<FormGroup<SingleEquipmentForm>>;
    let equipments = equipmentsControl.controls.map((equipment) => equipment.controls.equipmentNumber.value).filter((x) => x !== '');
    if (this.checkIfDuplicateExists(equipments)) {
      return { equipmentNumberUniqueValidator: { error: 'Duplicate Equipment Numbers are not allowed' } };
    } else {
      return null;
    }
  }

  private checkIfDuplicateExists(arr: string[]): boolean {
    return new Set(arr).size !== arr.length;
  }
}
